module.exports = __webpack_public_path__ + "img/logo@2x.537a76f1.png";